import { Button } from "@/components/ui/button";

export const SignalOperationsHeader = ({
  signalMode = "AUTO",
  botRuntime = "unknown",
  executionPath = "signal->intent->execution",
  currentBlocker = "-",
  lastSignalAt = "-",
  lastTradeAt = "-",
  onGoScanner,
}) => {
  return (
    <header className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="signal-operations-header-card">
      <div className="flex flex-wrap items-center justify-between gap-3" data-testid="signal-operations-header-row">
        <div data-testid="signal-operations-header-copy">
          <h1 className="text-4xl font-semibold text-slate-900" data-testid="signal-operations-header-title">Signal</h1>
          <p className="text-sm text-slate-600" data-testid="signal-operations-header-subtitle">Operasyon ekranı: sinyalin başına ne geldi, neden trade olmadı.</p>
        </div>
        <Button type="button" variant="outline" onClick={onGoScanner} data-testid="signal-operations-header-go-scanner-button">Scanner’a Git</Button>
      </div>

      <div className="mt-4 grid gap-2 text-sm sm:grid-cols-2 lg:grid-cols-3" data-testid="signal-operations-header-metrics">
        <p data-testid="signal-operations-header-signal-mode">Signal mode: <strong>{signalMode}</strong></p>
        <p data-testid="signal-operations-header-bot-runtime">Bot runtime: <strong>{botRuntime}</strong></p>
        <p data-testid="signal-operations-header-execution-path">Execution path: <strong>{executionPath}</strong></p>
        <p data-testid="signal-operations-header-current-blocker">Current blocker: <strong>{currentBlocker}</strong></p>
        <p data-testid="signal-operations-header-last-signal">Son sinyal: <strong>{lastSignalAt}</strong></p>
        <p data-testid="signal-operations-header-last-trade">Son trade: <strong>{lastTradeAt}</strong></p>
      </div>
    </header>
  );
};
